module.exports = __webpack_public_path__ + "img/nl_Ecran 5.215a3752.png";